export const SS_OUTLINED_INPUT = 'custom-css-outlined-input';

export const detailFieldSx = {
  width: '100%',
  '& .MuiInputBase-input': { fontSize: '14px' },
};

export const detailReadOnlyFieldSx = {
  ...detailFieldSx,
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#f3f4f6',
    pointerEvents: 'none',
    cursor: 'default',
    '& fieldset': { borderColor: '#e5e7eb' },
    '&:hover fieldset': { borderColor: '#e5e7eb' },
    '&.Mui-focused fieldset': { borderColor: '#e5e7eb', borderWidth: '1px' },
  },
  '& .MuiInputBase-input': {
    fontSize: '14px',
    color: '#6b7280',
    cursor: 'default',
    WebkitTextFillColor: '#6b7280',
  },
  '& .MuiInputLabel-root': { color: '#9ca3af' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#9ca3af' },
};

export const detailGrid2 = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px 20px',
  width: '100%',
};

export const LAYOUT_MAX_WIDTH = 980;
